<div [ngClass]="{'block': isOpen}">
  <div class="chevronContainer">
    @if (!isOpen) {
      <fa-icon [icon]="faChevronDown" class="chevron"></fa-icon>
    }
    @if (isOpen) {
      <fa-icon [icon]="faChevronUp" class="chevron"></fa-icon>
    }
    </div><a (click)="toggle()">{{text}}</a>
  </div>
  @if (isOpen) {
    <div style="margin-left: 17px;"><ng-content></ng-content></div>
  }
